module.exports = __webpack_public_path__ + "media/images/common/draft_pr_common-9a9718122098e22bbc43cdd17ef13f13.png";